import React, {useEffect, useState, useRef} from 'react';
import Header from '../../components/Header/Header';
import Button from '../../components/Button/Button';
import Footer from '../../components/Footer/Footer';
import {Col, Container, Row, UncontrolledPopover, FormGroup, Label, Input} from 'reactstrap';
import './booth.scss'
import {useTranslation, Trans} from 'react-i18next';
import BrowseCategories from "../../components/BrowseCategories/BrowseCategories";
import {Badge, Modal, ModalHeader, ModalBody} from 'reactstrap';
import '../../assets/styles/colors.scss';
import CheckCrossMark from '../../components/CheckCrossMark/CheckCrossMark';
import { useParams } from 'react-router';
import axios from '../../config/axios-interceptor';
import RequestQuoteModal from './RequestQuoteModal/RequestQuoteModal';
import {useHistory, Link, NavLink} from 'react-router-dom';
import CalendarModal from './CalendarModal/CalendarModal';
import {user} from '../../store/actions/auth.actions'
import {useSelector, useDispatch} from 'react-redux';

const Booth = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch()
  const params: any = useParams();
  
  const auth_user = useSelector((state) => state.auth.user);
  const isVisitor = auth_user && auth_user.isVisitor

  const [companyLoading, setCompanyLoading] = useState(true)
  const [companyError, setCompanyError] = useState(false)
  const [company, setCompany] = useState<any>({})

  const [boothModal, setBoothModal] = useState(false);
  const toggleBoothModal = () => setBoothModal(!boothModal);

  const [businessModal, setBusinessModal] = useState(false);
  const toggleBusinessModal = () => setBusinessModal(!businessModal);

  const countriesImageNames = ['kosovo', 'albania', 'macedonia', 'montenegro', 'bulgaria', 'holanda', 'bosnia']

  useEffect(() => {
    dispatch(user());
    getCompany(params.id)
  }, [])

  const getCompany = async (companyId: number) => {
    try {
      setCompanyLoading(true)
      const response = await axios.get(`Company/${companyId}`);

      if(response?.data?.succeeded) {
        setCompany(response?.data?.data)
        console.log('companye: ', response.data.data)
        setCompanyError(false)
        setCompanyLoading(false)
      } else {
        setCompanyError(true)
      }
    } catch (err) {
      setCompanyError(true)
      setCompanyLoading(false)
    }
  }

  const [calendarModal, setCalendarModal] = useState(false);
  const toggleCalendarModal = () => {
    setCalendarModal(!calendarModal);
  }

  return (
    <div>
      <Header/>
      <CalendarModal
        companyId={parseInt(params.id)}
        isCalendarOpen={calendarModal}
        toggleCalendarModal={toggleCalendarModal}
      />

      <RequestQuoteModal
        companyId={parseInt(params.id)}
        isRequestQuoteModalOpen={boothModal}
        toggleRequestQuoteModal={toggleBoothModal}
      />

      <Modal isOpen={businessModal} toggle={toggleBusinessModal} contentClassName="border-0"
              style={{boxShadow: '0px 0px 10px 0px #80C32D', border: '2px solid #80C32D', borderRadius: '6px'}}>
        <ModalBody className="pb-3 pt-1">
          <div className="text-center">
            <CheckCrossMark/>
            <h2 className="font-weight-bolder mt-5 mb-3">{t('boothSuccess')}</h2>
            <h6 className="font-weight-lighter mb-4">{t('boothBusinessCard')}</h6>
            <Button onClick={toggleBusinessModal} className="float-right rounded"
                    type="primary"
                    text="OK"></Button>
          </div>
        </ModalBody>
      </Modal>

      {!companyLoading ?
      <div className="bgimg pt-2 pb-5 pb-lg-5 pt-lg-4">
        <Container className="position-relative pb-5">
          {!companyError ?
            <>
              <Link to="/lobby" className="text-center mb-5 mt-2 pl-3 d-inline-block">
                <Button className="bMob2" text={t('btnPres')} type="gradient2" />
              </Link>
              
              {/* <div className="navigation-arrow-left d-none d-lg-block">
                <img src={require('../../assets/images/arrow.png')}/>
              </div> */}

              <Row className="mobilebooth">
                <Col lg={4}>
                  <div className="app-bg-primary booth-column-1-inner mx-auto mt-4 p-4 pt-5">
                    <div className="backgroundGradient w-75 py-3 px-4 booth-column-text-wrp">
                      <p style={{fontSize: '14px'}} className="text-center text-uppercase text-dark m-0 ">{t('pBooth1')}</p>
                      <p style={{fontSize: '14px'}} className="text-center text-uppercase font-weight-bold text-dark m-0">{company.companyName}</p>
                    </div>

                    <div className="pt-3 text-center">
                      <a href={company?.documents.length > 0 ? company?.documents[0].url : '#'} className="mt-3 document-button">{t('boothBtn1')}</a>
                      <Button onClick={toggleBoothModal} className="mt-2"
                              type="booths2btn"
                              text={t('boothBtn2')}/>
                      {isVisitor && <Button className="mt-2"
                              type="booths2btn"
                              text={t('boothBtn3')}
                              onClick={() => toggleCalendarModal()}
                              />}
                      <Button onClick={toggleBusinessModal}  className="mt-2"
                              type="booths2btn"
                              text={t('boothBtn4')}/>
                    </div>
                    <div className="mt-5 px-4 text-center d-flex justify-content-around flex-wrap">
                      {company?.facebookUrl ? <a href={company?.facebookUrl}>
                        <img className="mb-3" src={require('../../assets/images/fb-white.png')}/>
                      </a> : null}
                      {company?.instagramUrl ? <a href={company?.instagramUrl}>
                        <img className="mb-3" src={require('../../assets/images/insta-white.png')}/>
                      </a> : null}
                      {company?.linkedInUrl ? <a href={company?.linkedInUrl}>
                        <img className="mb-3" src={require('../../assets/images/in-white.png')}/>
                      </a>: null}
                    </div>
                  </div>
                </Col>
                <Col lg={8} className="px-5 px-lg-0 position-relative">
                  {/* <div className="navigation-arrow-left d-lg-none" style={{left: '4px'}}>
                    <img src={require('../../assets/images/arrow.png')} />
                  </div> */}

                  <div className="position-relative">
                    <img
                      className="position-absolute w-100"
                      style={{maxWidth: '11%', top: '9%'}}
                      src={require(`../../assets/images/${countriesImageNames[company?.countryId - 1]}.png`)}
                    />
                    
                    {company?.videos.length > 0 &&
                      <div className="position-absolute booth-video">
                        <video controls autoPlay muted loop className="w-100"
                          // src={require('../../assets/videos/video-presentation2.mp4')}
                          src={company?.videos[0].url}
                        />
                      </div>}

                    {company?.images?.length > 0 && <img
                      className="position-absolute w-100 booth-image"
                      // style={{maxWidth: '26%',top: '29%', left: '49%', transform: `translateX(-50%)`}}
                      style={{ transform: `translateX(-50%)`}}
                      // src="https://linkplus-it.com/assets/img/lp-logo.svg"
                      src={company?.images[0].url}
                    />}

                    <img
                      className="position-absolute w-100"
                      style={{maxWidth: '13%', top: '75%', left: '10%', transform: `translateX(-50%)`}}
                      src={require('../../assets/images/ChatIcon.png')}
                    />


                    <NavLink to={`/meet/${company.uniqueUrl}`}>
                      <img
                        className="position-absolute w-100"
                        style={{maxWidth: '13%', top: '75.5%', left: '28%', transform: `translateX(-50%)`}}
                        src={require('../../assets/images/CallIcon.png')}
                      />
                    </NavLink>

                    {/* watsapp icon */}
                    {company.phoneNumber ? <a href={`https://wa.me/${company?.phoneNumber}`} target="_blank">
                      <img
                        className="position-absolute w-100"
                        style={{maxWidth: '6%', top: '89%', left: '10.5%', transform: `translateX(-50%)`}}
                        src={require('../../assets/images/Whatsap.svg')}
                      />
                    </a> : null}

                    {/*/!* viber icon *!/*/}
                    {/*<img*/}
                    {/*  className="position-absolute w-100"*/}
                    {/*  style={{maxWidth: '6%', top: '89%', left: '13.5%', transform: `translateX(-50%)`}}*/}
                    {/*  src={require('../../assets/images/Viber.svg')}*/}
                    {/*/>*/}

                    {/* <img className="w-100 mt-5 mt-lg-0" src={require('../../assets/images/single-booth.png')}/> */}
                    <img className="w-100 mt-5 mt-lg-0" src={require(`../../assets/images/StandEmpty-${company.countryId <= 8 || company.countryId >= 1 ? company.countryId : 2}.png`)}/>
                  </div>

                  {/* <div className="navigation-arrow-right d-lg-none" style={{right: '4px'}}>
                    <img src={require('../../assets/images/arrow.png')} />
                  </div> */}
                </Col>
              </Row>

              {/* <div className="navigation-arrow-right d-none d-lg-block">
                <img src={require('../../assets/images/arrow.png')}/>
              </div> */}
            </>
          :
            <h1>Company not found</h1>}
        </Container>
      </div>
    : 
      <div className="bgimg pt-2 pb-5 py-lg-5">
        <Container className="position-relative py-5">
          <Row>
            <Col lg={4}>
              <div className="w-100" style={{height: '400px', backgroundColor: '#eaeef1'}}></div>
            </Col>
            <Col lg={8}>
              <div className="w-100" style={{height: '560px', backgroundColor: '#eaeef1'}}></div>
            </Col>
          </Row>
        </Container>
      </div>}

      <BrowseCategories/>
      <Footer/>
    </div>
  );
}

export default Booth;